import { QueryClient } from '@tanstack/react-query'
import { INotificationContentHandler } from '@/lib/handler/notification-content-handler'
import { NotificationType } from '@/types/notification'

/**
 * Products Excel Import Content Handler
 * Updates cache when a product import job is completed
 */
export default class ProductsExcelImportContentHandler implements INotificationContentHandler {
  async handle(notification: NotificationType, queryClient: QueryClient): Promise<void> {
    const { payload } = notification

    if (!payload || !payload.id) {
      return
    }

    const importId = payload.id
    const status = payload.status
    const createdTotal = payload.createdTotal
    const updatedTotal = payload.updatedTotal
    const failedTotal = payload.failedTotal
    const total = payload.total
    const message = payload.message

    const listQueries = queryClient.getQueriesData({ queryKey: ['productExcelImports'] })

    listQueries.forEach(([queryKey, oldData]: [any, any]) => {
      if (!oldData || !oldData.items) {
        return
      }

      const itemExists = oldData.items.some((item: any) => item.id === importId)

      if (itemExists) {
        queryClient.setQueryData(queryKey, {
          ...oldData,
          items: oldData.items.map((item: any) =>
            item.id === importId
              ? {
                  ...item,
                  status,
                  createdTotal,
                  updatedTotal,
                  failedTotal,
                  total,
                  message,
                  updatedAt: payload.updatedAt
                }
              : item
          )
        })
      }
    })

    const detailQueries = queryClient.getQueriesData({ queryKey: ['productExcelImport', importId] })

    detailQueries.forEach(([queryKey, oldData]: [any, any]) => {
      if (!oldData) {
        return
      }

      queryClient.setQueryData(queryKey, {
        ...oldData,
        status,
        createdTotal,
        updatedTotal,
        failedTotal,
        total,
        updatedAt: payload.updatedAt
      })
    })

    await queryClient.invalidateQueries({
      queryKey: ['productExcelImports'],
      refetchType: 'all'
    })

    await queryClient.invalidateQueries({
      queryKey: ['productExcelImport', importId],
      refetchType: 'all'
    })

    await queryClient.invalidateQueries({
      queryKey: ['products'],
      refetchType: 'all'
    })

    await queryClient.invalidateQueries({
      queryKey: ['product'],
      refetchType: 'all'
    })
  }
}
